const trialLocations = (): void => {
  const classes = {};

  const selectors = {
    trialID: '[data-trial-id]',
    trialIDAttr: 'data-trial-id',
    trialLocations: '[data-trial-locations]',
  };

  const trialLocationSections = document.querySelectorAll(selectors.trialID);

  const toTitleCase = (str: string): string => {
    const withoutUnderscores = str.replace(/_/g, ' ');
    return withoutUnderscores.replace(
      /\w\S*/g,
      (text: string) =>
        text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  };

  const toClassName = (str: string): string => {
    const withoutUnderscores = str.replace(/_/g, '-');
    return withoutUnderscores.replace(/\w\S*/g, (text: string) =>
      text.toLowerCase()
    );
  };

  if (trialLocationSections) {
    trialLocationSections.forEach((section) => {
      const trialID = section.getAttribute(selectors.trialIDAttr);
      const trialLocationAccordionsContainer = section.querySelector(
        selectors.trialLocations
      );

      const fetchData = async () => {
        try {
          const response = await fetch(
            `https://clinicaltrials.gov/api/v2/studies/${trialID}`
          );
          const data = await response.json();

          console.log('data', data);

          const locations =
            data.protocolSection.contactsLocationsModule.locations;

          const countrySet = new Set();

          locations.forEach((location: any) => {
            if (location.country) {
              countrySet.add(location.country);
            }
          });

          const uniqueCountries = Array.from(countrySet).sort();

          if (uniqueCountries && trialLocationAccordionsContainer) {
            uniqueCountries.forEach((country) => {
              const countryHeader = document.createElement('div');
              countryHeader.innerHTML = country as string;
              countryHeader.classList.add('country', 'h3');
              trialLocationAccordionsContainer.appendChild(countryHeader);

              locations
                .filter((location: any) => location.country === country)
                .forEach((location: any) => {
                  const item = document.createElement('div');
                  item.setAttribute('data-trial-location-accordion', '');

                  if (
                    location.geoPoint &&
                    location.geoPoint.lat &&
                    location.geoPoint.lon
                  ) {
                    item.setAttribute(
                      'data-trial-location-accordion-location-lat',
                      location.geoPoint.lat
                    );
                    item.setAttribute(
                      'data-trial-location-accordion-location-lon',
                      location.geoPoint.lon
                    );
                  }

                  const button = document.createElement('button');
                  button.classList.add('item__toggle', 'h5');
                  button.innerHTML =
                    location.facility + '<i class="fas fa-chevron-down"></i>';

                  const content = document.createElement('div');
                  content.classList.add('item__content');

                  // Status

                  const status = location.status;

                  if (status) {
                    const statusWrapper = document.createElement('div');
                    statusWrapper.classList.add('item__status');

                    const statusSpan = document.createElement('span');
                    statusSpan.classList.add(toClassName(status));
                    statusSpan.innerHTML = toTitleCase(status);

                    statusWrapper.appendChild(statusSpan);
                    content.appendChild(statusWrapper);
                  }

                  // Address

                  const addressWrapper = document.createElement('div');
                  addressWrapper.classList.add('item__address');

                  const addressInnerHeading = document.createElement('div');
                  addressInnerHeading.classList.add('inner__heading');
                  addressInnerHeading.innerHTML = 'Address';

                  const addressInnerContent = document.createElement('div');
                  addressInnerContent.classList.add('inner__content');

                  const facility = location.facility;
                  const city = location.city;
                  const country = location.country;
                  const zip = location.zip;

                  if (facility) {
                    addressInnerContent.innerHTML =
                      addressInnerContent.innerHTML +
                      facility +
                      '<span>, </span>';
                  }

                  if (city) {
                    addressInnerContent.innerHTML =
                      addressInnerContent.innerHTML + city + '<span>, </span>';
                  }

                  if (country) {
                    addressInnerContent.innerHTML =
                      addressInnerContent.innerHTML +
                      country +
                      '<span>, </span>';
                  }

                  if (zip) {
                    addressInnerContent.innerHTML =
                      addressInnerContent.innerHTML + zip + '<span>, </span>';
                  }

                  addressWrapper.appendChild(addressInnerHeading);
                  addressWrapper.appendChild(addressInnerContent);

                  content.appendChild(addressWrapper);

                  // Contacts

                  const contacts = location.contacts;
                  if (contacts) {
                    const contactsWrapper = document.createElement('div');
                    contactsWrapper.classList.add('item__contacts');

                    const contactsInnerHeading = document.createElement('div');
                    contactsInnerHeading.classList.add('inner__heading');
                    contactsInnerHeading.innerHTML = 'Contacts';
                    contactsWrapper.appendChild(contactsInnerHeading);

                    contacts.forEach((contact: any) => {
                      const contactsInnerContent =
                        document.createElement('div');
                      contactsInnerContent.classList.add('inner__content');

                      const name = contact.name;
                      const email = contact.email;
                      const phone = contact.phone;
                      const role = contact.role;

                      if (role && role != 'CONTACT') {
                        if (role.includes('_')) {
                          // Nothing
                          contactsInnerContent.innerHTML =
                            contactsInnerContent.innerHTML +
                            `${toTitleCase(role.replace('_', ' '))}` +
                            ': ';
                        } else {
                          contactsInnerContent.innerHTML =
                            contactsInnerContent.innerHTML + role + '<br/>';
                        }
                      }
                      if (name) {
                        contactsInnerContent.innerHTML =
                          contactsInnerContent.innerHTML + name + '<br/>';
                      }
                      if (email) {
                        contactsInnerContent.innerHTML =
                          contactsInnerContent.innerHTML + email + '<br/>';
                      }
                      if (phone) {
                        contactsInnerContent.innerHTML =
                          contactsInnerContent.innerHTML + phone + '<br/>';
                      }

                      contactsWrapper.appendChild(contactsInnerContent);
                    });

                    content.appendChild(contactsWrapper);
                  }

                  const spacerDiv = document.createElement('div');
                  content.appendChild(spacerDiv);

                  item.appendChild(button);
                  item.appendChild(content);
                  trialLocationAccordionsContainer.appendChild(item);
                });
            });

            const openAccordion = (accordion: HTMLElement): void => {
              const toggle = accordion.querySelector('.item__toggle');
              toggle.classList.add('item__toggle--active');
              const content =
                accordion.querySelector<HTMLElement>('.item__content');
              content.style.maxHeight = content.scrollHeight + 'px';

              const googleMap = section.querySelector('[data-google-map]');
              const lat = accordion.getAttribute(
                'data-trial-location-accordion-location-lat'
              );
              const lon = accordion.getAttribute(
                'data-trial-location-accordion-location-lon'
              );

              if (googleMap && lat && lon) {
                const mapOptions = {
                  mapId: 'Location',
                  center: { lat: parseFloat(lat), lng: parseFloat(lon) },
                  zoom: 14,
                  mapTypeId: google.maps.MapTypeId.ROADMAP,
                };

                const map = new google.maps.Map(googleMap, mapOptions);

                // @ts-ignore
                new google.maps.marker.AdvancedMarkerElement({
                  position: { lat: parseFloat(lat), lng: parseFloat(lon) },
                  map,
                });
              }
            };

            const closeAccordion = (accordion: HTMLElement): void => {
              const toggle = accordion.querySelector('.item__toggle');
              toggle.classList.remove('item__toggle--active');
              const content =
                accordion.querySelector<HTMLElement>('.item__content');
              content.style.maxHeight = null;
            };

            const locationsAccordions = section.querySelectorAll<HTMLElement>(
              '[data-trial-location-accordion]'
            );

            locationsAccordions.forEach((accordion) => {
              const title =
                accordion.querySelector<HTMLElement>('.item__toggle');
              const content =
                accordion.querySelector<HTMLElement>('.item__content');

              title.onclick = (): void => {
                if (content.style.maxHeight) {
                  closeAccordion(accordion);
                } else {
                  locationsAccordions.forEach((accordion) =>
                    closeAccordion(accordion)
                  );
                  openAccordion(accordion);
                }
              };
            });

            (locationsAccordions.item(0) as HTMLElement)
              .querySelector<HTMLElement>('.item__toggle')
              .click();
          }
        } catch (error) {
          console.error('Error:', error);
        }
      };

      fetchData();
    });
  }
};

export default trialLocations;
